// eslint-disable-next-line no-restricted-imports
import { v4 as uuid } from "uuid";

export function v4() {
  return uuid();
}
